/* eslint-disable */

module.exports = () => {
  require('babel-polyfill');
};
